import { normalizeRelations, resolveRelations } from '../helpers';

const state = {
  allIds: [],
  byId: {}
};

const getters = {
  find: (state, _, __, rootGetters) => id =>
    resolveRelations(state.byId[id], ['order_packages'], rootGetters, {
      inCart: true
    }),
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addPackages: ({ commit, dispatch }, packages) => {
    // package cannot be used as an identifier... using 'p' instead
    packages.forEach(p => {
      commit('add', normalizeRelations(p, ['order_packages']));
      dispatch('cartOrderPackages/addOrderPackages', p.order_packages || [], {
        root: true
      });
    });
  }
};

const mutations = {
  add: (state, p) => {
    state.byId[p.id] = p;
    if (state.allIds.includes(p.id)) return;
    state.allIds.push(p.id);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
